import { LAYOUT_UI_STRINGS } from "src/data";
import { LoginForm } from "src/features/users/components/login-form";
const Login = () => {
  return (
    <div className="flex-1">
      <div className="p-10 lg:p-20">
        <h3 className="text-heading-50 font-[600] text-2xl mb-6">
          {LAYOUT_UI_STRINGS["welcome-to"]}
          <strong className="font-[800] text-3xl">Taaly!</strong>
        </h3>
        <h4 className="font-[600] text-xl mb-6">{LAYOUT_UI_STRINGS["login-here"]}</h4>
        <LoginForm />
      </div>
    </div>
  );
};

export default Login;
